import { guestPaths } from '~/plugins/router/routes/guest';
import { unverifiedUserPaths } from '~/plugins/router/routes/unverified-user';
import { userPaths } from '~/plugins/router/routes/user';

import type { AuthConfig } from './_config.type';

/** Authentication config. */
const authConfig: AuthConfig = {
  routes: {
    guest: guestPaths,
    unverifiedUser: unverifiedUserPaths,
    user: userPaths,
  },

  redirect: {
    signin: '/',
    error: '/error',
  },
};

export default authConfig;
